var _module_exports ="<div ui-view=\"sidebar\"></div>\n\n<div class=\"main-content smaller nopadding\">\n    <div ui-view=\"details\"></div>\n</div>";;
var path = '/app/Main/systemOwnerReview/reviewUniquePermissions/ReviewUniquePermissions.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;